<template>
  <div class="about content">
    <Head @give-user="getUser" />
    <section class="header-box">
      <div class="header-inner">
        <span>Welcome</span>
        <h1 v-if="userName">I Am {{ userName }}</h1>
        <h6>{{ content.substr(0, count) }}</h6><span class="typed-cursor">|</span>
        <div class="scroll-down">
          <span></span>
        </div>
      </div>
    </section>
    <section class="about-box">
      ..
    </section>
  </div>
</template>
<script>
import Head from '@/components/Head.vue';

export default {
  name: 'show',
  components: { Head },
  data: function() {
    return {
      userName: '',
      addTimer: null,
      cutTimer: null,
      skillList: ['Web Developer', 'Photography', 'UI/UX  Designer'],
      skillIdx: 0,
      content: 'Web Developer',
      count: 0
    };
  },
  mounted() {
    var _this = this;
    let user = _this.$getStorage('user') || {};
    this.userName = user.userName;
    _this.count = _this.content.length;
    setTimeout(function(){
      _this.count = 0;
    }, 400);
    _this.initEvent('init');
  },
  beforeDestroy() {
    clearInterval(this.addTimer);
    clearInterval(this.cutTimer);
  },
  methods: {
    getUser(userName) {
      this.userName = userName;
    },
    initEvent: function(init) {
      var _this = this;
      _this.skillIdx++;
      _this.skillIdx = (_this.skillIdx >= _this.skillList.length) ? 0 : _this.skillIdx;
      _this.skillIdx = init ? 0 : _this.skillIdx;
      _this.content = _this.skillList[_this.skillIdx];
      setTimeout(function(){
        _this.addTag();
        _this.addTimer = setInterval(_this.addTag, 150);
      }, 500);
    },
    addTag: function() {
      var _this = this;
      if (_this.count == _this.content.length) {
        clearInterval(_this.addTimer);
        setTimeout(function(){
          _this.cutTag();
          _this.cutTimer = setInterval(_this.cutTag, 50);
        }, 1000);
      }
      this.count++;
    },
    cutTag: function() {
      var _this = this;
      if (_this.count == 0) {
        clearInterval(_this.cutTimer);
        _this.initEvent();
      }
      this.count--;
    }
  }
};
</script>
<style>
  @import url("https://fonts.googleapis.com/css?family=Montserrat:400,500,600,700,800,900|Open+Sans:400,600,700");
  .about { font-family: "Open Sans", sans-serif; font-size: 16px; line-height: 1.42857143; color: #222; margin: 0; }
  .about * { box-sizing: border-box; }
  h1,h2,h3,h4,h5,h6 { font-family: "Montserrat", sans-serif; }
  h1,h2,h3 { margin-top: 20px; }
  h4,h5,h6 { margin-top: 10px; }
  h1 { font-size: 48px; line-height: 1.0833333333333333; margin-bottom: 0.5416666666666666em; }
  h6 { font-size: 16px; line-height: 1.625; margin-bottom: 1.625em; }
  .header-box {
    background-image: url(../assets/about/header-bg-1.jpg);
    position: relative;
    width: 100%;
    height: 100vh;
    background-size: cover;
    background-position: center;
    margin-top: -50px;
    display: table;
    z-index: 1;
  }
  .header-box:after {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: -1;
    content: '';
    opacity: .8;
  }
  .header-box .header-inner {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    color: #fff;
  }
  .header-box .header-inner h1 {
    color: #fff;
    margin-bottom: 0;
    font-size: 80px;
    font-weight: 900;
    font-family: "Montserrat", sans-serif;
  }
  .header-box .header-inner h6 {
    color: #fff;
    display: inline-block;
  }
  .header-box .header-inner .typed-cursor {
    font-size: 25px !important;
    font-weight: 300;
    opacity: 1;
    -webkit-animation-duration: 1s;
    -moz-animation-duration: 1s;
    -o-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    -o-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    -webkit-animation-name: blink;
    -moz-animation-name: blink;
    -o-animation-name: blink;
    animation-name: blink;
    -webkit-animation-direction: "";
    -moz-animation-direction: "";
    -o-animation-direction: "";
    animation-direction: "";
  }
  .header-box .scroll-down {
    display: inline-block;
    height: 35px;
    width: 20px;
    border: 2px solid #fff;
    border-radius: 10px;
    position: absolute;
    left: 50%;
    bottom: 30px;
    -ms-transform: translate(-50%, 0);
    /* IE 9 */
    -webkit-transform: translate(-50%, 0);
    /* Chrome, Safari, Opera */
    transform: translate(-50%, 0);
  }
  .header-box .scroll-down span {
    height: 6px;
    width: 4px;
    border-radius: 50%;
    display: inline-block;
    background-color: #fff;
    -webkit-animation-duration: 1s;
    -moz-animation-duration: 1s;
    -o-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    -o-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    -webkit-animation-name: scrollDown;
    -moz-animation-name: scrollDown;
    -o-animation-name: scrollDown;
    animation-name: scrollDown;
    -webkit-animation-direction: ease-in;
    -moz-animation-direction: ease-in;
    -o-animation-direction: ease-in;
    animation-direction: ease-in;
    padding-top: 5px;
    margin-top: 5px;
  }
  @-webkit-keyframes blink {
    0% {
      opacity: 1; }
    50% {
      opacity: 0; }
    100% {
      opacity: 1; }
  }
  @-moz-keyframes blink {
    0% {
      opacity: 1; }
    50% {
      opacity: 0; }
    100% {
      opacity: 1; }
  }
  @-o-keyframes blink {
    0% {
      opacity: 1; }
    50% {
      opacity: 0; }
    100% {
      opacity: 1; }
  }
  @keyframes blink {
    0% {
      opacity: 1; }
    50% {
      opacity: 0; }
    100% {
      opacity: 1; }
  }
  @-webkit-keyframes scrollDown {
    0% {
      opacity: 0.5;
      margin-bottom: 20px; }
    50% {
      opacity: 1;
      margin-bottom: 1px; }
    100% {
      opacity: 0;
      margin-bottom: 0px; }
  }
  @-moz-keyframes scrollDown {
    0% {
      opacity: 0.5;
      margin-bottom: 20px; }
    50% {
      opacity: 1;
      margin-bottom: 1px; }
    100% {
      opacity: 0;
      margin-bottom: 0px; }
  }
  @-o-keyframes scrollDown {
    0% {
      opacity: 0.5;
      margin-bottom: 20px; }
    50% {
      opacity: 1;
      margin-bottom: 1px; }
    100% {
      opacity: 0;
      margin-bottom: 0px; }
  }
  @keyframes scrollDown {
    0% {
      opacity: 0.5;
      margin-bottom: 20px; }
    50% {
      opacity: 1;
      margin-bottom: 1px; }
    100% {
      opacity: 0;
      margin-bottom: 0px; }
  }
</style>
